import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJenisBiaya } from "@/services/getData"

export default function MasterJenisBiayaPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenisBiaya"],
    queryFn: getListJenisBiaya,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
